import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// ============================================================
// Fix para ResizeObserver loop error
// Este erro não-crítico ocorre em browsers modernos quando
// elementos mudam de tamanho durante o callback do observer
// ============================================================

// Método 1: Interceptar no window.error
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Método 2: Sobrescrever console.error para filtrar
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver loop') || 
      (typeof args[0] === 'object' && args[0]?.message?.includes?.('ResizeObserver loop'))) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Método 3: Wrapper do ResizeObserver com debounce
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    let rafId = null;
    const wrappedCallback = (entries, observer) => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
      rafId = requestAnimationFrame(() => {
        callback(entries, observer);
      });
    };
    super(wrappedCallback);
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// PWA: registra o service worker (app de bolso) + detecção de nova versão
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      const notifyUpdate = () => {
        if (reg.waiting) {
          window.dispatchEvent(new CustomEvent("pwa-update-available", { detail: reg }));
        }
      };
      notifyUpdate();
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) notifyUpdate();
        });
      });
      setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") reg.update().catch(() => {});
      });
    }).catch(() => {});

    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
